export type FundAccountCardState = 'none' | 'loading' | 'error' | 'unverified' | 'not_entitled' | 'ok';

export function cardState(
    selected: boolean,
    isLoading: boolean,
    isError: boolean,
    status: string | undefined,
): FundAccountCardState {
    if (!selected) return 'none';
    if (isLoading) return 'loading';
    if (isError) return 'error';
    if (status === 'unverified' || status === 'not_entitled' || status === 'ok') return status;
    return 'loading';
}
